import { Dropdown } from "ant-design-vue";
const { Button, ...other } = Dropdown;

const YwDropdown = {
	...other,
	name: "YwDropdown",
	Button: {
		...Button,
		name: "YwDropdownButton",
	},
};

YwDropdown.install = function (Vue) {
	Vue.component(YwDropdown.name, Dropdown);
	Vue.component(YwDropdown.Button.name, Dropdown.Button);
};

export default YwDropdown;
